import * as React from "react";
function SvgClose(props, svgRef) {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M5.63604 5.63605L18.364 18.364" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /><path d="M5.63604 18.364L18.364 5.63603" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgClose);
export default __webpack_public_path__ + "src/assets/icons/close.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/close_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/close_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/close_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/close_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/close_4x.svg"
};
export { ForwardRef as ReactComponent };